module.exports = __webpack_public_path__ + "img/playstore.acc8bbd2.png";